import { Component } from '@theme/component';

/**
 * Testimonials section: groups cards into a horizontal scroller and highlights a card on click/tap.
 * @extends {Component}
 */
class TestimonialsComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#groupCards();
    this.addEventListener('pointerdown', this.#onPointerDown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('pointerdown', this.#onPointerDown);
  }

  updatedCallback() {
    super.updatedCallback();
    this.#groupCards();
  }

  /**
   * Wrap consecutive testimonial cards in the scroller track,
   * so other theme blocks (text, button, etc.) can sit above/below normally.
   */
  #groupCards() {
    const container = this.querySelector('.testimonials__blocks');
    if (!(container instanceof HTMLElement)) return;

    // Unwrap previous groups (theme editor re-renders)
    container.querySelectorAll('.testimonials__track').forEach((track) => {
      const scroller = track.parentElement;
      if (!(scroller instanceof HTMLElement)) return;
      while (track.firstChild) {
        scroller.before(track.firstChild);
      }
      scroller.remove();
    });

    const children = Array.from(container.children);
    /** @type {Element[]} */
    let group = [];

    const flush = () => {
      if (group.length === 0) return;

      const scroller = document.createElement('div');
      scroller.className = 'testimonials__scroller';

      const track = document.createElement('div');
      track.className = 'testimonials__track';
      track.setAttribute('role', 'list');

      group[0].before(scroller);
      scroller.append(track);
      for (const card of group) {
        track.append(card);
      }
      group = [];
    };

    for (const child of children) {
      if (child.classList.contains('testimonial-card')) {
        group.push(child);
      } else {
        flush();
        child.classList.add('testimonials__extra');
      }
    }
    flush();
  }

  /**
   * @param {PointerEvent} event
   */
  #onPointerDown = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const card = target.closest('.testimonial-card');
    if (!(card instanceof HTMLElement) || !this.contains(card)) return;

    this.querySelectorAll('.testimonial-card.is-active').forEach((el) => {
      el.classList.remove('is-active');
    });
    card.classList.add('is-active');
  };
}

if (!customElements.get('testimonials-component')) {
  customElements.define('testimonials-component', TestimonialsComponent);
}
